import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { ServiceHourRanges } from 'src/app/component/service-administration/model/service-hour-ranges.model';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { ServiceDeliveries } from '../../model/service-deliveries.model';
import { TrackingHistory } from 'src/app/component/common-components/tracking-history/model/tracking-history.model';

@Injectable({
    providedIn: 'root'
})
export class ServiceDeliveryService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getEnrollmentPeriods(): Observable<any> {
        return this.get<any>(EndPoints.serviceDelivery_getEnrollmentPeriods).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getServiceCategory(): Observable<any> {
        return this.get<any>(EndPoints.serviceDelivery_getServiceCategory).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getStudentServices(studentID: number): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_getStudentServices, false, null, {
            studentID: studentID
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getStudentProvisionalServices(studentID: number): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_getStudentProvisionalServices, false, null, {
            studentID: studentID
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getCOSResons(): Observable<any> {
        return this.get<any>(EndPoints.serviceDelivery_getCOSResons).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    /*
		studentsSchoolYear: [{regionCode: '01', schoolYear: '2022-23', studentID: 123456}, {...}]
	*/
    getStudentEnrollmentsBySchoolDestrictScYrV2(studentsSchoolYear: any[]): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_getStudentEnrollmentsBySchoolDestrictScYrV2, false, null, {
            studentsSchoolYear: studentsSchoolYear
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schoolEnrollmentsString'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    /*
		serviceDelivery: ServiceDeliveries
		serviceHourRanges: [{PARTY_SERVICES_ID: 12345, SERVICE_HOUR_RANGES_ID: 1}]
		students: [{ID: 123456, GRADES_ID: 13}]
	*/
    createServiceDelivery(serviceDelivery: ServiceDeliveries, serviceHourRanges: any[], students: any[]): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_CreateServiceDelivery, false, null, {
            serviceDelivery: serviceDelivery,
            serviceHourRanges: serviceHourRanges,
            students: students
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    editServiceDelivery(serviceDelivery: ServiceDeliveries, editedFields: TrackingHistory[]): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_editServiceDelivery, false, null, {
            serviceDelivery: serviceDelivery,
            editedFields: editedFields
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteByID(serviceID: number): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_deleteByID, false, null, {
            serviceID: serviceID
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    editServiceDeliveryDates(serviceDelivery: ServiceDeliveries): Observable<any> {
        return this.post<any>(EndPoints.serviceDelivery_editServiceDeliveryDates, false, null, {
            serviceDelivery: serviceDelivery
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
